import React from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { useFavourites } from '../context/FavouritesContext';
import { useAuth } from '../context/AuthContext';
import { focusRing } from '../styles/ui';

// Top-level header entry point for favourites, parallel to CartBadge — the
// account-dropdown "Favourites" link stays for discoverability, but the
// brief's header spec lists Wishlist as its own icon alongside Cart, not
// nested a menu deep.
const WishlistBadge = () => {
  const { favouriteCount } = useFavourites();
  const { authStatus } = useAuth();

  return (
    <Link
      to={authStatus === 'authenticated' ? '/favourites' : '/login?redirect=%2Ffavourites'}
      aria-label={`View favourites${favouriteCount > 0 ? `, ${favouriteCount} item${favouriteCount === 1 ? '' : 's'}` : ''}`}
      className={`relative hidden md:inline-flex items-center justify-center w-11 h-11 rounded-xl text-emerald-900 hover:bg-emerald-50 transition-colors ${focusRing}`}
    >
      <Heart size={22} aria-hidden="true" />
      {authStatus === 'authenticated' && favouriteCount > 0 && (
        <span className="absolute top-1 right-1 min-w-[1.1rem] h-[1.1rem] px-1 rounded-full bg-accent-500 text-white text-[10px] font-bold flex items-center justify-center shadow-soft">
          {favouriteCount > 99 ? '99+' : favouriteCount}
        </span>
      )}
    </Link>
  );
};

export default WishlistBadge;
